import { useState } from "react";
import Plans from "./plans";
import Infos from './infos'
import styles from "./style.module.scss";

const Tabs = () => {
  const [selected, setSelected] = useState("Infos");
  return (
    <div className={styles.tabsContainer}>
      <div className={styles.buttonContainer}>
        <button
          onClick={() => setSelected("Infos")}
          className={selected === "Infos" && styles.selected}
        >
          Info
        </button>
        <button
          onClick={() => setSelected("Plans")}
          className={selected === "Plans" && styles.selected}
        >
          Plans
        </button>
      </div>
      <div className={styles.tabsContent}>
        {selected === "Infos" && <Infos />}
        {selected === "Plans" && <Plans />}
      </div>
    </div>
  );
};

export default Tabs;
